import React, {useContext, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import PageTitle from "../Commons/PageTitle";
import Tabs from "../UI/Tabs/Tabs";
import Invoices from "./Invoices";
import Payments from "./Payments";
import Statements from "./Statements";
import UserContext from "../../context/user-context";
import {userHaveSpecificPermission} from "../Utils/UserHelper";
import Helpbox from "../UI/Helpboxes/Helpbox";

function Documentation() {
    const userContext = useContext(UserContext);
    const {t} = useTranslation();

    if (!userHaveSpecificPermission(userContext.user, 'financial_data'))
        return null;

	return (
        <div className="container container--larger">

            <div className="row flex flex--wrap flex--align-baseline">
                <div className="col-lg-6">
                    <PageTitle title={t("docs.title")}/>
                </div>
				{(userContext && userContext.user.account && userContext.user.account.hasPreAuthorizedAccount !== true) &&
					<div className="col-lg-6">
						<Helpbox type={userContext.user.account.classification.code !== 'RES' ? 'ppa' : 'budget'} cta={true} column={true}/>
					</div>
				}
            </div>
            <Tabs>
                <div label={t("docs.tabs.invoices")} tabkey="invoices">
                    <Invoices/>
                </div>

                <div label={t("docs.tabs.payments")} tabkey="payments">
                    <Payments/>
                </div>

                <div label={t("docs.tabs.statements")} tabkey="statements">
                    <Statements/>
                </div>
            </Tabs>

        </div>
    );
}

export default Documentation;
